import {TramiteEstado, TramiteExpres} from "../tramites/components/interfaces/tramites.interface";
import {Asignacion} from "../../officials/asignaciones/interfaces/asignacion-interface";
import {UserSessionReq} from "../../shared/interfaces/user-session-req-interface";
import {ProyectoPerfil} from "./perfil.interface";
import {AreasInterfaces} from "../tramites/components/interfaces/formulario.interfaces";

/**
 * Interfaz homologada con API-VUC. 02JUL2024 15:32HRS.
 *
 * Usos verificados de esta interface: Proceso de asignación de solicitudes a tecnico resolutor.
 */
export interface ProyectoResponse {
    idProyecto: bigint;
    nombre: string;
    numeroExpediente: string;
    descripcion: string;
    creadoPor: string;
    fechaCreacion: string;
    naturaleza: string;
    tipoProyecto: string;
    entorno: string;
    regimen: string;
    tipoUsoSuelo: string;
    cobertura: string;
    relieve: string;
    estado: string;
    usuario: string;
    idInstitucion: number;
    idSolicitud: number;
    cantidadServicios: bigint;
    idEntorno: bigint;
    idTipoUsoSuelo: bigint;
    idTipoProyecto: bigint;
    tipoFlujo: string;
    idTipoFlujo: bigint;
    tieneProyectoDefinido: boolean;
}

/**
 * Interfaz utilizada por api: proyectos/consulta la cual consulta todos los proyectos por parametros.
 */
export interface ProyectoItem {
    idProyecto: number;
    nombre: string;
    numeroExpediente: string;
    descripcion: Descripcion;
    creadoPor: CreadoPor;
    fechaCreacion: Date;
    naturaleza: Naturaleza;
    tipoProyecto: TipoProyecto;
    entorno: Entorno;
    regimen: Regimen;
    tipoUsoSuelo: Entorno;
    cobertura: Cobertura;
    relieve: Relieve;
    estado: Estado;
    proyectoEstado?: Estado;
    usuario: Usuario;
    idInstitucion: number;
    idSolicitud?: number;
    cantidadTramites: number;
    idEntorno: number;
    idTipoUsoSuelo: number;
    idTipoProyecto?: number;
    solicitudTipo: string;
    idSolicitudTipo: number;
    idSolicitudEstado: number;
    estadoSolicitud: string;
    asignacion?: Asignacion[];
    ubicacionItem?: UbicacionItem
    elementoTerreno?: ElementoTerreno[]
    colindantes?: Colindantes[]
    areas?: Areas[]
    tenencia?: Tenencia[],
    autorizado?: boolean,
    idSectorProyecto?: number,
    sector?: string,
    idCategoriaProyecto?: number,
    categoria?: string,
    institucion?: string
    titular:Titular;
    cliente:Titular;
    evaluaciones?:EvaluacionesProyecto[];
    montoInversion?:number;
    tieneProyectoDefinido?: boolean;
    tieneTramitesVigentes?: boolean;
    detalleConstruccionItem?: DetalleConstruccionItem[];
    lotesItem?: LotesItem[];
    detalleProfesionalesItem?: ProyectoProfesionalesDetItem[];



    carnetGenerado: boolean;
    carnetDescargado: boolean;
    carnetLoading: boolean;
}


export interface NuevoProyectoItem {
    idProyecto?: number
    nombre?: string;
    numeroExpediente?: string;
    usuario?: string | null | '' | undefined;
    idSolicitud?: number;
    idInstitucion?: number;
    descripcion?: string;
    idNaturaleza?: string;
    idTipoProyecto?: string;
    idEntorno?: string;
    idRegimen?: string;
    idTipoUsoSuelo?: string;
    idCobertura?: string;
    idRelieve?: string;
    session: UserSessionReq;
    ubicacionItem: UbicacionItem;
    direccion: DireccionItem;
    departamento: CatalogoInterface,
    distrito: DistritoItem;
    elementosTerreno: ElementosTerrenoItem[];
    tenenciaLegal: ProyectoPerfil[];
    areas: AreasInterfaces[];
    colindantes: ColindanteItem[];
    idProyectoSector?: number;
    idProyectoInstitucion?: number;
    idTitular?: string;
    montoInversion:number;
    tieneProyectoDefinido?: boolean;
    tieneTramitesVigentes?: boolean;
}

export interface ProyectoCreadoItem {
    idProyecto: number;
    nombre: string;
    numeroExpediente: string;
    descripcion: string;
    creadoPor: string;
    fechaCreacion: Date;
    naturaleza: string | null;
    tipo: string | null;
    entorno: string | null;
    regimen: string | null;
    tipoUsoSuelo: string | null;
    cobertura: string | null;
    relieve: string | null;
    estado: string | null;
    usuario: string;
    idInstitucion: number;
    idSolicitud: number;
    tieneProyectoDefinido?: boolean;
}

export interface ProyectoTramiteItem {
    codigoInstitucion: string;
    nombreInstitucion: string;
    idTramite: string;
    nombreTramite: string;
    tarifaTramite: string;
    aplicaTarifario: boolean;
    codigoCategoria: string;
    nombreCategoria: string;
    tipoServicio: string;
    idFase: string;
    nombreFase: string;
    qtyglobal: number;
    qtycumplidos?: number;
    qtyrequeridos?: number;
    qtyopcionales?: number;
    qtypendientes?: number;
    idProyecto: number;
    idSolicitud?: number;
    tramiteEstado?: TramiteEstado | null;
    idEstadoTramite?: number;
    idCategoria?:string;
    tramiteExpres?:TramiteExpres;
}

export interface ListaOpcionesProyectoItem {
    code?: number,
    name?: string
}

/**
 * Campo <b>regulado</b> controla si el dato de este catálogo se utiliza
 * para validar procesos de aplicabilidad a proyectos según ley DOT.
 */
export interface CatalogoInterface {
    id: string;
    descripcion: string;
    estado: boolean;
    regulado?: boolean;
}

export interface ArchivoTipoInterface {
    idArchivoTipo: number;
    descripcion:   string;
    privado:       boolean;
}


export interface ColindanteItem {
    nombreColindante: string,
    ubicacion: string,
    idColindante: number,
    idProyecto?: number,
    usuarioCreaModifica?: string
}

export interface TenenciaItem {
    idTenencia: number;
    descripcion: string;
    estado: boolean;
    idRequisito:number;

}

export interface DistritoItem {
    idDistrito: number;
    descripcion: string;
}

export interface MunicipioItem {
    idMunicipio: number;
    descripcion: string;
    regulado?: boolean;
}

export interface DireccionItem {
    idDireccion?: number;
    complemento: string;
    idProyecto: number;
    idSolicitud?: number;
    idMunicipio: number;
    usuarioCreaModifica: string;
    estado?: boolean;
    complemento2: string;
    matricula?: string;
    claveCatastral?: string;
    latitud?: string;
    longitud?: string;
}

export interface ElementosTerrenoItem {
    idElementoTerreno: number;
    idProyecto: number;
    estado: boolean;
}

export interface ArchivoItem {
    idProyecto: number;
    idTipoArchivo: number;
    idArchivoEstado: number;
    nombre: string;
    tamano: number;
    hash: string;
    tipoArchivo: string;
    estadoArchivo: string;
    observaciones?: string;
    fechaCreacion?: string;
    ext?: string;
    privado?: boolean;
}

export interface EventItem {
    status?: boolean;
    date?: string;
    icon?: string;
    color?: string;
    iconSize?: string;
    name?: string;
    codigo?: number; //este representa el id proyecto o solicitud
}

export interface RequisitosFormulario {
    idRequisito: number | string;
    nombre: string;
    descripcion: string;
    estado: boolean;
    idRequisitoTipo: string;
    descripcionTipo: string;
    estadoTipo: boolean;
    aplicaCargaDocumento: boolean;
    aplicaFormulario: boolean;
    idArchivoEstadoRq: number;
}

export interface UbicacionItem {
    matricula: string;
    claveCatastral: string;
    latitud: number;
    longitud: number;
    idDireccion?: number;
    complemento?: string;
    complemento2?: string;
    distrito?: string;
    municipio?: string;
    departamento?: string;
}

export interface ElementoTerreno {
    idElementoTerrenoProyecto: number;
    tipoElemento: string;
    estado: number;
}

export interface Colindantes {
    idColindateProyecto: number;
    colindanteDescripcion: string;
    nombreColindante: string;
    estado: number;
}

export interface Areas {
    idArea: number;
    tipoArea: string;
    area: number;
    estado: number;
}

export interface Tenencia {
    idTenencia: number;
    tipoTenencia: string;
    persona: number;
    estado: number;
}
export interface Titular {
    uniqueId: string;
    usuario: string;
    nombreCompleto: string;
    telefono?:string;
}
export interface DetalleConstruccionItem {
    idDetalleConstruccion: number;
    descripcion?: string;
    cantidad?: number;
    nivel?: string;
    idProyecto?: number;
    idTramite?: number;
    tramite?: string;
    idFase?: number;
    idfase?: number;
}
export interface LotesItem {
    idLote: number;
    descripcion?: string;
    cantidad?: number;
    idProyecto?: number;
}
export interface ProyectoProfesionalesDetItem {
    idProyectoProfesionalesDet: number;
    idProyecto?: number;
    idProfesional: number;
    idProfesionDisenio: number;
    descripcionDisenio?: string;
    nombres?: string;
    apellidos?: string;
}
export interface DraftStatus{
    idStepRefresh:number | string;
    fecha:string | Date;
}
export interface EvaluacionesProyecto {
    idSolicitudEval: number;
    idSolicitud: number;
    idProyecto: number;
    idfase: number;
    estado: number;
    fechainicio: string;
}

export enum Cobertura {
    Pasto = "Pasto",
}

export enum CreadoPor {
    Sys = "SYS",
}

export enum Descripcion {
    Null = "null",
}

export enum Entorno {
    Habitacional = "Habitacional",
    NoHabitacional = "No Habitacional",
}

export enum Estado {
    Pendiente = "Pendiente",
}

export enum Naturaleza {
    Nuevo = "Nuevo",
}

export enum Regimen {
    Individual = "Individual",
}

export enum Relieve {
    LigeramenteInclinado02 = "Ligeramente Inclinado (0%-2%)",
}

export enum TipoProyecto {
    Urbanización = "Urbanización",
}

export enum Usuario {
    JohnDoe = "john.doe",
}
export enum Sector {
    SectorPublico = 1,
    SectorPrivado = 2
}

export enum FileCase {
    FileUpload = 1,//archivos documentos etc que se cargan
    ReuseFile = 2  //archivos, documentos etc que se reutilizan que ya estan registrados
}
export const enum TenenciaEnum {
    Conmodato = "1",
    Arrendatario = "2",
    Propietario = "3",
    Profesionales = "4",
    RepresentanteLegal = "5"
}

export const enum ArchivoTipoEnum {
    Planosactuales=1,
    Poder=2,
    Resolucionanda=3,
    Escrituramatrizcompraventa=4,
    Contratodecomodato=5,
    Contratodearrendamiento=6,
    Representantelegal=7,
    Planosporproyecto=8,
    Documentosyformularios=9,
    Anexovisitatecnica=10,
    Anexoinspeccion=11

}

export const enum ProjectType {
    Construccion = 'construccion',
    Lotificacion = 'lotificacion',
    ComplejoUrbano = 'complejoUrbano',
    ParcelacionesDelEstado = 'parcelacionesDelEstado',
    Infraestructura = 'Infraestructura',
    Otros = 'otros'
}


export interface CambioTitularReq {
  idProyecto: string;
  idTitular: string;
  session: UserSessionReq;
}
